import { render } from "./ThreatenedSpeciesChart.vue?vue&type=template&id=9f4d75f0&scoped=true"
import script from "./ThreatenedSpeciesChart.vue?vue&type=script&lang=js"
export * from "./ThreatenedSpeciesChart.vue?vue&type=script&lang=js"

import "./ThreatenedSpeciesChart.vue?vue&type=style&index=0&id=9f4d75f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f4d75f0"]])

export default __exports__